import { SET_ORDER_LOADING, SET_ORDERS, UNSET_ORDER_LOADING } from "../actions/orders"

const initialState = {
  loading: false,
  active_orders: []
}

export default function ordersReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ORDER_LOADING:
      return { ...state, loading: true }
      break
    case UNSET_ORDER_LOADING:
      return { ...state, loading: false }
      break
    case SET_ORDERS:
      return { ...state, active_orders: action.payload }
    default:
      return state
  }
}
